import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager,
  collection, addDoc, doc, getDoc, serverTimestamp,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

export const firebaseConfig = {
  apiKey: "AIzaSyA0UYlKcLi-_jqRY9x27YYQvRSnj_RYTVI",
  authDomain: "gestion-artistico.firebaseapp.com",
  projectId: "gestion-artistico",
  storageBucket: "gestion-artistico.firebasestorage.app",
  messagingSenderId: "605527344645",
  appId: "1:605527344645:web:798e8e6e88f82624e73e6c",
  measurementId: "G-70CL1YHKN0"
};

const DOMINIO_INTERNO = "gestion-artistico.local";
export const dniToEmail = (dni) => `${dni}@${DOMINIO_INTERNO}`;

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Copia local de los datos en el navegador (pedido de Mica, 2026-10-07: que
// todo ande más rápido). Las pantallas que leen colecciones grandes
// (productos, publicaciones) arrancan desde lo ya descargado y después solo
// bajan lo que cambió. Funciona con varias pestañas abiertas a la vez. Si el
// navegador no lo permite (ej. ventana privada), sigue como antes, sin copia.
function crearFirestore() {
  try {
    return initializeFirestore(app, {
      // 200 MB (antes quedaba el tope de 40 MB): solo el catálogo, las
      // publicaciones de ML y los clientes ya pasan los 15 MB, y al llenarse
      // el navegador borraba datos que después volvía a bajar enteros
      // (Mica, 2026-10-15: que todo ande más rápido).
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
        cacheSizeBytes: 200 * 1024 * 1024,
      }),
    });
  } catch (_) {
    return getFirestore(app);
  }
}
export const db = crearFirestore();
export const functions = getFunctions(app, 'us-east1'); // misma region que functions/index.js
export const storage = getStorage(app);

export async function registrarActividad(accion, detalle = '') {
  const user = auth.currentUser;
  if (!user) return;
  let nombre = '';
  try {
    const snap = await getDoc(doc(db, 'usuarios', user.uid));
    if (snap.exists()) nombre = snap.data().nombre || '';
  } catch (_) {
    // si falla la lectura del nombre, igual queda registrada la actividad
  }
  try {
    await addDoc(collection(db, 'actividad'), {
      uid: user.uid,
      dni: user.email?.split('@')[0] || '',
      nombre,
      accion,
      detalle,
      fecha: serverTimestamp(),
    });
  } catch (_) {
    // no bloquear la acción del usuario si falla el registro de actividad
  }
}
